import { createAction, createAsyncAction } from "@shared/store/helpers";
import { EvalRunListFilter, PaginatedResponse, WithCallback, WithLoaderFlag } from "@shared/interfaces";
import { EvalCategoryModel, EvalRunDetailModel, EvalRunModel } from "@shared/models";

import { EvaluationActionTypes } from "./constants";
import { RunEvalFromCsvDto } from "../interface";

export const getEvalRuns = createAsyncAction(
  EvaluationActionTypes.GET_EVAL_RUNS,
  EvaluationActionTypes.GET_EVAL_RUNS_SUCCESS,
  EvaluationActionTypes.GET_EVAL_RUNS_FAILURE,
)<WithLoaderFlag<EvalRunListFilter>, PaginatedResponse<EvalRunModel>, Error>();

export const getEvalRun = createAsyncAction(
  EvaluationActionTypes.GET_EVAL_RUN,
  EvaluationActionTypes.GET_EVAL_RUN_SUCCESS,
  EvaluationActionTypes.GET_EVAL_RUN_FAILURE,
)<WithLoaderFlag<{ uuid: string }>, EvalRunDetailModel, Error>();

export const deleteEvalRun = createAsyncAction(
  EvaluationActionTypes.DELETE_EVAL_RUN,
  EvaluationActionTypes.DELETE_EVAL_RUN_SUCCESS,
  EvaluationActionTypes.DELETE_EVAL_RUN_FAILURE,
)<string, string, Error>();

export const runEvalFromCsv = createAsyncAction(
  EvaluationActionTypes.RUN_EVAL_FROM_CSV,
  EvaluationActionTypes.RUN_EVAL_FROM_CSV_SUCCESS,
  EvaluationActionTypes.RUN_EVAL_FROM_CSV_FAILURE,
)<WithCallback<RunEvalFromCsvDto>, EvalRunDetailModel, Error>();

export const getEvalCategories = createAsyncAction(
  EvaluationActionTypes.GET_EVAL_CATEGORIES,
  EvaluationActionTypes.GET_EVAL_CATEGORIES_SUCCESS,
  EvaluationActionTypes.GET_EVAL_CATEGORIES_FAILURE,
)<undefined, EvalCategoryModel[], Error>();

export const downloadEvalTemplate = createAsyncAction(
  EvaluationActionTypes.DOWNLOAD_EVAL_TEMPLATE,
  EvaluationActionTypes.DOWNLOAD_EVAL_TEMPLATE_SUCCESS,
  EvaluationActionTypes.DOWNLOAD_EVAL_TEMPLATE_FAILURE,
)<undefined, undefined, Error>();

export const setEvalRunsFilter = createAction(EvaluationActionTypes.SET_EVAL_RUNS_FILTER)<EvalRunListFilter | null>();

export const clearEvalRun = createAction(EvaluationActionTypes.CLEAR_EVAL_RUN)();
